import { render, staticRenderFns } from "./LazyImage.vue?vue&type=template&id=397d3a1f&lang=html&"
import script from "./LazyImage.vue?vue&type=script&lang=js&"
export * from "./LazyImage.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./LazyImage.vue?vue&type=style&index=0&lang=sass&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "2a41675a"
  
)

export default component.exports